import React, { Component } from 'react';

import { withTranslation } from "react-i18next";

function AddressNoTranslation(props) {
  const { t } = props;
  return (
    <div className="common-address">
      <b className="address-text "><a href="http://maps.google.com/?q=oripando hostel granada">{t('general.address', { framework: 'React' })}</a></b>
    </div>
  );
}

const Address = withTranslation('common')(AddressNoTranslation)

export default Address;


// WEBPACK FOOTER //
// ./src/features/common/Address.js